var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "jzliu-bi-engine-bi-header" },
    [
      _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "jzliu-bi-engine-bi-header-content" }, [
        _c("div", { staticClass: "dashboard-action-panel" }, [
          _c("div", { staticClass: "action-panel-left" }, [
            _c("i", {
              staticClass: "el-icon-s-data jzliu-bi-engine-bi-header-icon",
            }),
            _vm._v(" "),
            _vm.isEditMode
              ? _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.gridLayout.dashboardName,
                      expression: "gridLayout.dashboardName",
                    },
                  ],
                  staticClass: "middle jzliu-bi-engine-bi-header-name-input",
                  attrs: { type: "text" },
                  domProps: { value: _vm.gridLayout.dashboardName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.gridLayout,
                        "dashboardName",
                        $event.target.value
                      )
                    },
                  },
                })
              : _c("span", [_vm._v(_vm._s(_vm.gridLayout.dashboardName))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false",
                },
              ],
              staticClass: "action-panel-middle",
            },
            [
              _c("div", { staticClass: "device-switch-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "switch-content",
                    on: {
                      click: function ($event) {
                        return _vm.switchActive(true)
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-monitor" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "switch-content",
                    on: {
                      click: function ($event) {
                        return _vm.switchActive(false)
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-mobile" })]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "switch-bar", style: _vm.switchPos }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action-panel-right" },
            [
              _c(
                "div",
                { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.onCance } },
                    [_vm._v("取消")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showShareBtn
                ? _c(
                    "div",
                    { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "mini" }, on: { click: _vm.onShare } },
                        [_vm._v("分享")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.onExportImg } },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.btnPreview } },
                    [_vm._v("预览")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("button"),
              _vm._v(" "),
              _vm.showExportJson
                ? _c(
                    "div",
                    { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.btnExportJson },
                        },
                        [_vm._v("导出JSON")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "jzliu-bi-engine-bi-header-btn-wrapper" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.btnSaveAndRelease("save")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.showPublishBtn
                ? _c(
                    "div",
                    {
                      staticClass: "jzliu-bi-engine-bi-header-btn-wrapper",
                      staticStyle: { "margin-right": "12px" },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.btnSaveAndRelease("publish")
                            },
                          },
                        },
                        [_vm._v("保存并发布")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "链接分享",
            visible: _vm.shareDialogVisible,
            width: "480px",
            "append-to-body": "",
            "modal-append-to-body": "",
            "close-on-click-modal": false,
            "close-on-press-escape": true,
            "custom-class": "share-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.shareDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "share-content" }, [
            _c(
              "div",
              { staticClass: "url-input-container" },
              [
                _c("el-input", {
                  staticClass: "url-input",
                  attrs: { readonly: "", placeholder: "请复制链接分享给他人" },
                  model: {
                    value: _vm.currentPageUrl,
                    callback: function ($$v) {
                      _vm.currentPageUrl = $$v
                    },
                    expression: "currentPageUrl",
                  },
                }),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "copy-btn",
                    attrs: { type: "primary", loading: _vm.copyLoading },
                    on: { click: _vm.copyUrl },
                  },
                  [_vm._v("\n          复制链接\n        ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }